exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainProduct__header{text-transform:uppercase;font-family:Oswald;font-weight:700;font-size:24px;margin:0 0 10px}@media only screen and (max-width:935px){.mainProduct__header{font-size:24px;-ms-flex:0 0 100%;flex:0 0 100%;margin:0 0 10px}}@media only screen and (max-width:730px){.mainProduct__header{font-size:24px;-ms-flex:0 0 100%;flex:0 0 100%;padding:0 35px;box-sizing:border-box;margin:0 0 10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73810a09","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mainHeader.vue
// module id = 30
// module chunks = 0